import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import AuthCard from '../components/auth/AuthCard.tsx';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Por favor, preencha todos os campos');
      return;
    }

    try {
      setError('');
      setLoading(true);
      const result = await login(email, password);
      if (result.status === 'mfa_required') {
        navigate('/login/mfa', { state: { email: result.email, mfaToken: result.mfaToken } });
        return;
      }
      navigate('/dashboard');
    } catch (err: unknown) {
      const error = err as Error;
      setError(error.message || 'Falha na autenticação. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      title="Entrar"
      subtitle="Acesse sua conta com e-mail e senha."
      error={
        error ? (
          <div className="auth-error">
            <strong>Não foi possível entrar</strong>
            {error}
          </div>
        ) : null
      }
      footer={
        <>
          <button type="submit" form="login-form" className="btn btn-primary" disabled={loading}>
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
          <div className="auth-links">
            <span className="auth-link muted" style={{ cursor: 'default' }}>
              Esqueci minha senha
            </span>
          </div>
        </>
      }
    >
      <form id="login-form" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="email-address">E-mail</label>
          <input
            id="email-address"
            className="input"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="seu@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Senha</label>
          <input
            id="password"
            className="input"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="••••••••"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
      </form>
    </AuthCard>
  );
};

export default Login;
